import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=4fb0de9f&scoped=true&"
import script from "./ContentItem.vue?vue&type=script&lang=js&"
export * from "./ContentItem.vue?vue&type=script&lang=js&"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=4fb0de9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0de9f",
  null
  
)

export default component.exports